import { render, staticRenderFns } from "./doctor_list.vue?vue&type=template&id=497b0cde&scoped=true&"
import script from "./doctor_list.vue?vue&type=script&lang=js&"
export * from "./doctor_list.vue?vue&type=script&lang=js&"
import style0 from "./doctor_list.vue?vue&type=style&index=0&id=497b0cde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497b0cde",
  null
  
)

export default component.exports